<template>
  <div
    class="navbar-container d-flex content align-items-center"
    :class="envLabel ? 'env-banner' : ''"
  >
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
      <span
        v-if="envLabel"
        class="ml-1"
        style="font-weight: bold; text-transform: uppercase; font-size: 18px"
        >{{ envLabel }}</span
      >
      <span class="ml-1" style="font-size: 12px" v-else>
        v. 9.0.0
      </span>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- Pausa: escolher o tipo ou, em pausa, cronômetro e contagem regressiva -->
      <pause-control />
      <!-- Chat: atalho com o total de mensagens não lidas -->
      <chat-badge />
      <!-- Indicador do nó ativo -->
      <b-nav-item
        v-if="selectedNode"
        class="d-none d-md-flex align-items-center mr-1"
        :title="$t('navbar.switchNode')"
        @click="$router.push('/select-node')"
        style="cursor: pointer"
      >
        <feather-icon
          icon="GitBranchIcon"
          size="16"
          class="mr-50 text-primary"
        />
        <span class="text-primary font-weight-bold" style="font-size: 0.85rem">
          {{ selectedNode.name }}
        </span>
      </b-nav-item>
      <!-- Seletor de idioma -->
      <b-nav-item-dropdown
        right
        class="mr-50 language-dropdown"
        toggle-class="d-flex align-items-center"
      >
        <template #button-content>
          <div class="d-flex align-items-center language-button">
            <img
              v-if="user.locale"
              :src="(localeOptions.find((o) => o.value === user.locale) || {}).flagImg"
              class="lang-flag mr-50"
              :alt="user.locale"
            />
            <feather-icon icon="GlobeIcon" size="16" />
          </div>
        </template>
        <b-dropdown-item
          v-for="option in localeOptions"
          :key="option.value"
          @click="changeLocale(option.value)"
          :class="[
            'd-flex align-items-center language-item',
            { 'selected-language': user.locale === option.value },
          ]"
        >
          <img :src="option.flagImg" class="lang-flag mr-50" :alt="option.value" />
          <span class="language-label">{{ option.label }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none flex-column user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user.name }}
            </p>
            <span
              v-if="user.professional_name"
              class="text-primary"
              style="font-size: 0.75rem; line-height: 1"
            >
              {{ user.professional_name }}
            </span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="user.photo"
            class="badge-minimal"
            :badge-variant="statusBadgeVariant"
            :title="$t('supervision.status.' + operatorStatus)"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <router-link :to="'/profile'">
            <span>{{ $t("navbar.myProfile") }}</span>
          </router-link>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MailIcon" class="mr-50" />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{ $t("navbar.logout") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import PauseControl from "./PauseControl.vue";
import ChatBadge from "./ChatBadge.vue";
import env from "../../config/env";

const ENV_LABELS = {
  dev: "DEV",
  homolog: "Ambiente de Homologação",
  apresentacao: "Apresentação",
};

export default {
  data() {
    return {
      authenticated: false,
      disabled: true,
      user: {},
      localeOptions: [
        { value: "pt", label: "Português", flagImg: require("@/assets/images/flags/br.png") },
        { value: "en", label: "English", flagImg: require("@/assets/images/flags/en.png") },
        { value: "es", label: "Español", flagImg: require("@/assets/images/flags/es.png") },
      ],
    };
  },
  components: {
    PauseControl,
    ChatBadge,
    BLink,
    BNavbarNav,
    BNavItem,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  computed: {
    operatorStatus() {
      return this.$store.state.operator_status;
    },
    // Verde operando, laranja ocioso, vermelho em pausa.
    statusBadgeVariant() {
      return { operating: "success", idle: "warning", paused: "danger" }[this.operatorStatus] || "success";
    },
    selectedNode() {
      return this.$store.state.selected_node;
    },
    envLabel() {
      return ENV_LABELS[env.mode] || null;
    },
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    changeLocale(locale) {
      this.$store.dispatch("changeLocale", locale).catch(() => {
        this.$message("Erro", "Não foi possível salvar o idioma.", "error");
      });
    },
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      axios
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          self.$router.push({ path: "/login" });

          setTimeout(function () {
            location.reload();
          }, 500);
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
  },
  mounted() {
    const self = this;
    setTimeout(function () {
      self.user = self.$store.state.user;
      console.log(self.user);
      if (self.user.password_expired == 1) {
        $("#modalChangePassword").modal({
          backdrop: "static",
          keyboard: false, // to prevent closing with Esc button (if you want this too)
        });
      }
    }, 500);
  },
};
</script>
<style scoped>
.env-banner {
  background-color: rgb(236, 92, 92);
  color: white !important;
  border-radius: 7px;
}
/* Language selector styles (refined) */

.language-dropdown .dropdown-menu {
  min-width: 180px;
  padding: 6px 6px;
  box-shadow: 0 8px 28px rgba(32, 33, 36, 0.08);
  border-radius: 8px;
}
.language-item {
  padding: 6px 8px;
  display: flex;
  align-items: center;
}
.language-button .lang-flag,
.language-item .lang-flag {
  width: 20px;
  height: auto;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  margin-right: 10px;
}
.language-item .language-label {
  font-size: 0.95rem;
  color: #333;
}
/* Active / hover */
.language-item:hover,
.language-item:focus {
  background: rgba(23, 74, 132, 0.045);
}
.language-item.active,
.language-item.dropdown-item.active {
  /* neutral selected state (no heavy blue) */
  background: rgba(0, 0, 0, 0.04) !important;
  color: inherit !important;
}
.language-item.active .language-label,
.language-item.dropdown-item.active .language-label {
  color: inherit !important;
  font-weight: 700;
}
/* Custom selected class to avoid bootstrap active styles */
.selected-language {
  background: rgba(0, 0, 0, 0.04) !important;
}
.selected-language .language-label {
  font-weight: 700;
}
</style>
